import { Component } from '@angular/core';
import { UnknowFailureProvider } from '../../providers'

@Component({
  selector: 'unknow-failure',
  templateUrl: 'unknow-failure.html'
})
export class UnknowFailureComponent {

  public isFailed: boolean = false;

  constructor(
    unknowFailure: UnknowFailureProvider
  ) {
    unknowFailure.isOnFailure().subscribe((response) => {
      this.isFailed = response;
    });
  }

  setOn()
  {
    this.isFailed = true;
  }

  setOff()
  {
    this.isFailed = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/unknow-failure/unknow-failure.ts